import React from 'react';
import LectureItem from './LectureItem';

const LectureList = (props) => {
    return (
        <div class="col-xs-12 col-md-6">
            <ul class="timeline">
							
							
							
							
                
            
            

                { props.days.length > 0 && (props.days.filter( item => {return item.dayName === props.selectedDay})[0].slotItems.map((item) =>
                
                 <LectureItem dayName={props.selectedDay} item={item}/>))
                
                
                }
              </ul>
            

        </div>
    );
};

export default LectureList;


// WEBPACK FOOTER //
// ./src/pages/student_schedule/LectureList.js